import { render, staticRenderFns } from "./list-detail.vue?vue&type=template&id=396c45c8&scoped=true&"
import script from "./list-detail.vue?vue&type=script&lang=tsx&"
export * from "./list-detail.vue?vue&type=script&lang=tsx&"
import style0 from "./list-detail.vue?vue&type=style&index=0&id=396c45c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c45c8",
  null
  
)

export default component.exports